import numeral from 'numeral';

const PERCENTAGE_TYPES = {
  DEFAULT: '0,0.0%',
  DEFAULT_SIGNED: '+0,0.0%',
  NO_DECIMAL: '0,0%',
  NO_DECIMAL_SIGNED: '+0,0%',
  TWO_DECIMALS: '0,0.00%'
};
function formatPercentage(value, format = 'DEFAULT') {
  if (value === null || value === undefined) return '';
  return numeral(value).format(PERCENTAGE_TYPES[format]);
}

export { PERCENTAGE_TYPES, formatPercentage };
